<script setup lang="ts">
import { ref } from 'vue';
import FsumDialog from '@/components/Utilities/FsumDialog.vue';

defineProps<{
    title?: string;
    message?: string;
    admins: string[];
    persistent: boolean;
}>();

const dialogRef = ref<typeof FsumDialog>();
</script>
<template>
    <FsumDialog
        ref="dialogRef"
        :title="title"
        :message="message"
        :persistent="persistent"
        :card-classes="'q-pa-lg'"
    >
        <template #content>
            <ul>
                <li
                    v-for="admin, index in admins"
                    :key="index"
                >
                    {{ admin }}
                </li>
            </ul>
        </template>
    </FsumDialog>
</template>
<style scoped>
</style>
